import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';

export default function Settings() {
  const location = useLocation();
  const isProfile = location.pathname === '/admin/dashboard/settings';
  const isChangePassword = location.pathname === '/admin/dashboard/settings/change-password';

  return (
    <div className="settings-page">
      <div className="settings-content">
        <div className="settings-navigation">
          <Link
            to="/admin/dashboard/settings"
            className={`settings-nav-item ${isProfile ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Profile</span>
            <img
              src={window.getPublicUrl ? window.getPublicUrl('/assets/images/ArrorRighticon.svg') : '/assets/images/ArrorRighticon.svg'}
              alt="arrow"
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/admin/dashboard/settings/change-password"
            className={`settings-nav-item ${isChangePassword ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Change Password</span>
            <img
              src={window.getPublicUrl ? window.getPublicUrl('/assets/images/ArrorRighticon.svg') : '/assets/images/ArrorRighticon.svg'}
              alt="arrow"
              className="settings-nav-arrow-icon"
            />
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
}
